import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingRoutingModule } from './landing.routes';
import { LandingComponent } from './landing.component';
import { InicioComponent } from './inicio/inicio.component';
import { CompartidoModule } from '../landing/compartido/compartido.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReglasComponent } from './reglas/reglas.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Resultados107Component } from './resultados107/resultados107.component';
import { CalendarioComponent } from './calendario/calendario.component';
import { EstadisticasComponent } from './estadisticas/estadisticas.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@NgModule({
  declarations: [
    LandingComponent,
    InicioComponent,
    ReglasComponent,
    Resultados107Component,
    CalendarioComponent,
    EstadisticasComponent
  ],
  imports: [
    CommonModule,
    CompartidoModule,
    LandingRoutingModule,
    NgbModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    PdfViewerModule
  ]
})
export class LandingModule { }
